<template>
  <div class="offline-stats-modal" v-if="isVisible">
    <div class="modal-overlay" @click="closeModal"></div>
    <div class="modal-content">
      <div class="modal-header">
        <h2>🤖 Добро пожаловать обратно!</h2>
        <button class="close-button" @click="closeModal">×</button>
      </div>
      
      <div class="stats-content">
        <div class="stat-card">
          <div class="stat-icon">⏱️</div>
          <div class="stat-info">
            <h3>Время оффлайна</h3>
            <p class="stat-value">{{ formatOfflineTime(offlineTime) }}</p>
          </div>
        </div>
        
        <div class="stat-card">
          <div class="stat-icon">💰</div>
          <div class="stat-info">
            <h3>Накоплено монет</h3>
            <p class="stat-value">{{ formatNumber(coinsEarned) }}</p>
          </div>
        </div>
        
        <div class="stat-card">
          <div class="stat-icon">⚡</div>
          <div class="stat-info">
            <h3>Уровень авто-бота</h3>
            <p class="stat-value">{{ autoTapLevel }}</p>
          </div>
        </div>
        
        <div class="stat-card">
          <div class="stat-icon">⏱️</div>
          <div class="stat-info">
            <h3>Интервал кликов</h3>
            <p class="stat-value">{{ formatInterval(autoTapInterval) }}</p>
          </div>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="continue-button" @click="closeModal">
          Продолжить игру
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'OfflineStatsModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const offlineTime = ref(0);
    const coinsEarned = ref(0);
    const autoTapLevel = ref(0);
    const autoTapInterval = ref(20000); // 20 секунд по умолчанию

    // Загружаем данные из localStorage
    onMounted(() => {
      const lastVisit = localStorage.getItem('lastVisitTime');
      const offlineCoins = localStorage.getItem('offlineCoinsEarned') || '0';
      const level = localStorage.getItem('autoTapLevel') || '0';
      const interval = localStorage.getItem('autoTapInterval') || '20000';
      
      if (lastVisit) {
        offlineTime.value = Date.now() - parseInt(lastVisit);
      }
      
      coinsEarned.value = parseInt(offlineCoins);
      autoTapLevel.value = parseInt(level);
      autoTapInterval.value = parseInt(interval);
    });

    const closeModal = () => {
      // Сохраняем время последнего визита
      localStorage.setItem('lastVisitTime', Date.now().toString());
      localStorage.setItem('offlineCoinsEarned', '0');
      emit('close');
    };

    const formatOfflineTime = (milliseconds) => {
      const seconds = Math.floor(milliseconds / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      
      if (days > 0) return `${days}д ${hours % 24}ч`;
      if (hours > 0) return `${hours}ч ${minutes % 60}м`;
      if (minutes > 0) return `${minutes}м ${seconds % 60}с`;
      return `${seconds}с`;
    };

    const formatNumber = (num) => {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    };

    const formatInterval = (ms) => {
      const seconds = ms / 1000;
      if (seconds >= 60) {
        return `${(seconds / 60).toFixed(1)} мин`;
      }
      return `${seconds} сек`;
    };

    return {
      offlineTime,
      coinsEarned,
      autoTapLevel,
      autoTapInterval,
      closeModal,
      formatOfflineTime,
      formatNumber,
      formatInterval
    };
  }
};
</script>

<style scoped>
.offline-stats-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2000;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 400px;
  background: linear-gradient(135deg, #1a1a2e, #16213e);
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.modal-header h2 {
  color: #fff;
  font-size: 22px;
  margin: 0;
  text-align: center;
  flex-grow: 1;
}

.close-button {
  background: none;
  border: none;
  color: #aaa;
  font-size: 28px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #fff;
}

.stats-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 25px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 15px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.stat-icon {
  font-size: 24px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

.stat-info h3 {
  color: #aaa;
  font-size: 12px;
  margin: 0 0 5px 0;
  font-weight: 500;
}

.stat-value {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.modal-footer {
  text-align: center;
}

.continue-button {
  background: linear-gradient(135deg, #00c9ff, #92fe9d);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 201, 255, 0.4);
}

.continue-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 201, 255, 0.6);
}

@media (max-width: 480px) {
  .stats-content {
    grid-template-columns: 1fr;
  }
  
  .modal-content {
    padding: 20px;
  }
}
</style>